import React from "react";
import { useState, useEffect } from "react";
import "../CSS/header.css";
import { Header } from "./Header";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import aboutPic4 from "../Project Images/aboutPic4.png";
import aboutPic5 from "../Project Images/aboutPic5.jpeg";
import Developer_Image from "../Project Images/Developer_Image.jpg";
import Marketing_Manager_Image from "../Project Images/Marketing_Manager_Image.jpg";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";

export const AboutUs = () => {
  const [showComponent, setShowComponent] = useState(false);
  useEffect(() => {
    setShowComponent(true);
  }, []);

  const whoWeAre = {
    textAlign: "center",
    height: "90px",
    width: "95%",
    margin: "0 auto",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
  };

  return (
    <>
      <Header />

      <br />
      <div
        className={showComponent ? "about-container show" : "about-container"}
        style={{ padding: "20px" }}
      >
        <div style={whoWeAre}>
          <h2 className="WhoWeareHeading">Who We Are</h2>
          <p className="WhoWeareHeadingPara">
            We are experts in <b>Digital Marketing</b> and{" "}
            <b>Web Development</b> With our innovative strategies and
            cutting-edge technologies, we help businesses thrive in the digital
            landscape. From boosting online visibility to crafting engaging user
            experiences, we are committed to delivering exceptional results that
            exceed expectations.
          </p>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />

        {/* Digital Marketer Details */}
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "60px",
            height: "350px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.5)",
            borderRadius: "10px",
          }}
        >
          <img
            src={Marketing_Manager_Image}
            style={{
              width: "270px",
              height: "270px",
              marginLeft: "15px",
              float: "left",
              marginRight: "20px",
              borderRadius: "200px",
            }}
          />
          <div>
            <h3
              style={{
                fontFamily: "Verdana, Geneva, Tahoma, sans-serif",
                fontSize: "40px",
                fontWeight: "bold",
              }}
            >
              Amulya N
            </h3>
            <span
              style={{ borderBottom: "3px solid red", paddingBottom: "5px" }}
            >
              <h5
                style={{
                  fontFamily: "Verdana, Geneva, Tahoma, sans-serif",
                  fontSize: "25px",
                  display: "inline-block",
                }}
              >
                Managing Director and Digital Marketing Expert
              </h5>
            </span>

            <p style={{ lineHeight: "1.7", fontSize: "20px" }}>
              As the Managing Director and Digital Marketing Expert, I lead our
              organization with a unique blend of visionary leadership and
              hands-on digital marketing expertise. With a deep understanding of
              both business strategy and digital marketing tactics, I bring a
              dynamic approach to achieving our company's goals in today's
              digital landscape.
            </p>
          </div>
        </div>

        <br />
        <br />

        {/* Developer Details */}
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "60px",
            height: "350px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.5)",
            borderRadius: "10px",
          }}
        >
          <img
            src={Developer_Image}
            style={{
              width: "270px",
              height: "270px",
              marginLeft: "15px",
              float: "right",
              marginRight: "20px",
              borderRadius: "200px",
            }}
          />
          <div>
            <h3
              style={{
                fontFamily: "Verdana, Geneva, Tahoma, sans-serif",
                fontSize: "40px",
                fontWeight: "bold",
              }}
            >
              JayaraJ BS
            </h3>
            <span
              style={{ borderBottom: "3px solid red", paddingBottom: "5px" }}
            >
              <h5
                style={{
                  fontFamily: "Verdana, Geneva, Tahoma, sans-serif",
                  fontSize: "25px",
                  display: "inline-block",
                }}
              >
                Developer
              </h5>
            </span>

            <p style={{ lineHeight: "1.7", fontSize: "20px"}}>
              As a proficient web developer, I bring expertise in crafting
              immersive digital experiences through innovative web solutions.
              With a keen eye for detail and a passion for clean, efficient
              code, I specialize in building dynamic and responsive websites
              that captivate users and drive engagement. Leveraging a diverse
              skill set encompassing front-end and back-end technologies, I am
              dedicated to delivering high-quality, user-centric websites that
              exceed expectations and elevate brands in the digital realm
            </p>
          </div>
        </div>

        <br />
        <br />


        <CardGroup>
          <div className="row">
            <div className="row justify-content-center">
              <div className="col-md-6 mb-4">
                <Card className="border-0 shadow">
                  <Card.Img
                    variant="top"
                    src={aboutPic4}
                    style={{ width: "588px", height: "450px" }}
                  />
                  <Card.Body>
                    <Card.Title>
                      <b>Expertise in Digital Marketing</b>
                    </Card.Title>
                    <Card.Text style={{ fontSize: "18px" }}>
                      <li>Search engine marketing (PPC)</li>
                      <li>Social Media Marketing</li>
                      <li>Display Advertising</li>
                      <li>Influencer Marketing</li>
                      <li>Content marketing</li>
                      <b>Advertising Services we provide</b>
                      <li>Amazon Advertising</li>
                      <li>Flipkart Ads</li>
                      <li>Facebook and Instagram Ads (Meta)</li>
                      <li>Google Ads</li>
                      <li>Keywords planning</li>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>

              <div className="col-md-6 mb-4">
                <Card className="border-0 shadow">
                  <Card.Img
                    variant="top"
                    src={aboutPic5}
                    style={{ width: "588px", height: "450px" }}
                  />
                  <Card.Body>
                    <Card.Title>
                      <b>Specialized in WEB DEVELOPMENT</b>
                    </Card.Title>
                    <Card.Text style={{ fontSize: "18px" }}>
                      At Expertise Specialized Web Development, we don't just
                      build websites, we engineer digital experiences that
                      redefine success in the online world.
                      <li>Responsive Web Design </li>
                      <li>UI/UX Design</li>
                      <li>Web Security</li>
                      <li>Database Management</li>
                      <li>SEO Optimization </li>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        </CardGroup>
      </div>
    </>
  );
};
